export const NetIntroduceCardList = [
    {
        title: "空基规划",
        img: "images/Guide/IntroducePages/NetIntroduce/1.png",
        introduce: "为全面推进陆地观测卫星共性应用支撑平台健康快速发展，实现空间资源规模化、业务化、产业化发展，根据等国民经济和社会发展的重大需求和相关总体要求，制定本规划。",
        location: "/Introduce",
        index: 0,
    },
    {
        title: "空基卫星",
        img: "images/Guide/IntroducePages/NetIntroduce/4.png",
        introduce: "提供空基十二五卫星、空基十三五卫星、高分系列卫星、其他卫星数据科普。",
        location: "/Introduce",
        index: 1,
    },
    {
        title: "共性应用支撑平台",
        img: "images/Guide/IntroducePages/NetIntroduce/5.png",
        introduce: "国家民用空间基础设施陆地观测卫星共性应用支撑平台建成了包括48个真实性检验站、6个综合实验场在内的国家级真实性检验场网系统、共性技术支撑服务系统，形成服务能力。",
        location: "/Introduce",
        index: 2,
    },
    {
        title: "光学微波检验站网",
        img: "images/Guide/IntroducePages/NetIntroduce/2.png",
        introduce: "实现针对不同的产品，依托现有行业、科研机构现有的场站网资源，在全国范围内选择符合自然条件和空间分布需求的，新增部分地基测量设备，实现高频次、自动化的测量数据；并将该测量数据经过预处理后传输至共性应用技术支撑服务系统。",
        location: "/GXWB",
    },
    // {
    //     title: "基础数据影像",
    //     img: "images/Guide/IntroducePages/NetIntroduce/3.png",
    //     introduce: "基础卫星影像数据科普包括了获取、处理和应用卫星影像，在地球观测、环境监测、城市规划等领域有着重要应用。",
    //     location: "/geovis",
    // },
    {
        title: "综合试验场",
        img: "images/Guide/IntroducePages/NetIntroduce/8.png",
        introduce: "由东北、华北、华中、华南、西北、西南六个综合实验场构成，主要开展星-空-地同步大型综合实验，为空基卫星的综合性能评价提供基础数据。",
        location: "/ZHSY",
    },
    {
        title: "应用培训",
        img: "images/Guide/IntroducePages/NetIntroduce/7.png",
        introduce: "提供共性技术研究、数据应用示范、应用推广案例等类型的在线培训资料。",
        location: "/OnlineTraining",
    },
    {
        title: "项目大事记",
        img: "images/Guide/IntroducePages/NetIntroduce/6.png",
        introduce: "记录和展示软件平台的重要事件和发展历程。通过该功能，用户可以了解软件平台的过去、现在和未来的重要节点，更好地理解软件平台的演变和进步。",
        location: "/Introduce",
        index: 4,
    },
];
export const NetIntroduceMenuList = [
    {
        title: "知识库",
        introduce: "链接知识库，查看分类的知识文档",
        location: "/GuideSearch",
    },
    {
        title: "在线论坛",
        introduce: "上论坛提问具体问题，交流学习",
        location: "/Q&ACenter",
    },
]

export const ResourcesSearchCardList = [
    {
        title: "卫星数据",
        img: "images/Guide/IntroducePages/ResourcesSearch/1.png",
        introduce: "提供空基十二五卫星、空基十三五卫星、高分系列卫星等卫星数据检索、浏览与共享下载。",
        location: "/geovis",
    },
    {
        title: "共性产品",
        img: "images/Guide/IntroducePages/ResourcesSearch/2.png",
        introduce: "提供6类24种共性产品检索、详情查看与下载。",
        location: "/GXJS",
    },
    {
        title: "地面实测数据共享",
        img: "images/Guide/IntroducePages/ResourcesSearch/3.png",
        introduce: "地面实测数据集共享涉及48个地面站点和6个综合实验场的数据，通过数据集共享，促进科学研究、环境监测和城市规划等领域的合作与创新。",
        location: "/DMSJ",
    },
    {
        title: "模型算法下载",
        img: "images/Guide/IntroducePages/ResourcesSearch/4.png",
        introduce: "提供遥感算法的检索、下载。",
        location: "/AlgorithmModelSharing",
    },
    {
        title: "软件工具下载",
        img: "images/Guide/IntroducePages/ResourcesSearch/5.png",
        introduce: "提供图像处理生成工具的检索、下载。",
        location: "/AlgorithmToolsSharing",
    },
]

export const TechnicalServiceCardList = [
    // {
    //     title: "综合实验场",
    //     img: "images/Guide/IntroducePages/TechnicalService/1.png",
    //     introduce: "由东北、华北、华中、华南、西北、西南六个综合实验场构成，主要开展星-空-地同步大型综合实验，为空基卫星的综合性能评价提供基础数据。",
    //     location: "/ZHSY",
    // },
    {
        title: "地面实测数据采集",
        img: "images/Guide/IntroducePages/TechnicalService/2.png",
        introduce: "地面实测数据采集是通过在地面设置站点或试验场，并利用各种传感器、仪器或设备进行观测和测量，获取有关地理信息和环境数据的过程。",
        location: "/DMSJ",
    },
    {
        title: "地面实测数据处理",
        img: "images/Guide/IntroducePages/TechnicalService/3.png",
        introduce: "地面实测数据处理是指对通过地面站点和实验场采集到的数据进行分析、清理和整理的过程，以提取有用信息并为后续应用做准备。",
        location: "/DMSJ",
    },
    {
        title: "产品真实性检验",
        img: "images/Guide/IntroducePages/TechnicalService/4.png",
        introduce: "依托现有观测站网建设，在全国范围内选择一定数量典型区域的观测场、站，天地一体化同步观测采集相关数据，实现产品与算法的质量与稳定度检验，支撑基于自主遥感数据的算法研发并对卫星应用效能进行评价。",
        location: "/GXWBCPJY",
    },
    {
        title: "处理流程定制",
        img: "images/Guide/IntroducePages/TechnicalService/5.png",
        introduce: "用户可以根据自身需求对自己发布的流程进行增删改查，或者再编辑。也可以查看自己已经发布的流程，对自己发布的流程进行管理。",
        location: "/processdesign",
    },
    {
        title: "产品生产定制",
        img: "images/Guide/IntroducePages/TechnicalService/6.png",
        introduce: "将平台作为服务，提供业务应用的开发环境和运行环境，调用强大的计算能力进行数据处理和信息产品生产。",
        location: "/geovis",
    },
    {
        title: "工具技术测评",
        img: "images/Guide/IntroducePages/TechnicalService/7.png",
        introduce: "立足已有国产卫星数据处理共性技术基础，着眼为未来共性技术发展和应用目标，为用户提供面向遥感应用全过程的稳定、可信、可追溯的数据处理共性技术工具集、技术检验评价工具集和在线技术检验评价实验测试环境。",
        location: "/GXJS",
    },
]